export default {
  gpathSession: state => state.gpathSession
}
